import React, { useState } from "react";
import ValuationsPanel from "./ValuationsPanel";
import AddValuationDialog from "./AddValuationDialog";

import { ThemeProvider } from "@mui/material/styles";
import { theme } from "../../styles/mui_theme";

interface Props {
    artworkId: number;
    reloadToken: number;
    onSave: (data: any) => void;
}

const ValuationsTabContent: React.FC<Props> = ({
    artworkId,
    reloadToken,
    onSave,
}) => {
    const [valDialogOpen, setValDialogOpen] = useState(false);

    return (
        <>
            <ThemeProvider theme={theme}>
            <ValuationsPanel
                artworkId={artworkId}
                onAdd={() => setValDialogOpen(true)}
                reloadToken={reloadToken}
            />

            <AddValuationDialog
                open={valDialogOpen}
                onClose={() => setValDialogOpen(false)}
                artworkId={artworkId}
                onSave={onSave}
                valuation={null}
                />
            </ThemeProvider>
        </>
    );
};

export default ValuationsTabContent;
